import { DATASET_SOURCE_LABELS, KPI_TYPE_LABELS } from '@constants/enumLabels';
import { DatasetSource, KPIType } from '@services/api/deckManagement/graphql/schema/API';

/**
 * Resolves the KPI Type to a valid KPI Type Label.
 *
 * When `null` or `undefined` is passed, returns `null` (caller handles default value).
 * @see {@link KPIType}
 * @see {@link KPI_TYPE_LABELS}
 * @param kpiType
 */
export const resolveKpiTypeLabel = (kpiType?: KPIType | null) => (kpiType ? KPI_TYPE_LABELS[kpiType] : null);

/**
 * Resolves the dataset source to a valid value.
 *
 * When `null` or `undefined` is passed, defaults to `DatasetSource.GALAXY`.
 * @see {@link DatasetSource}
 * @param source
 */
export const resolveDatasetSource = (source?: DatasetSource | null) => source ?? DatasetSource.GALAXY;

/**
 * Resolves the display label for a given dataset source.
 *
 * @see {@link DatasetSource}
 * @see {@link resolveDatasetSource}
 * @see {@link DATASET_SOURCE_LABELS}
 * @param source
 */
export const resolveDatasetSourceLabel = (source: Parameters<typeof resolveDatasetSource>[0]) =>
  DATASET_SOURCE_LABELS[resolveDatasetSource(source)];
